:host {
    display: block;
}

:host([slot="item"]) {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 24px 0;
}

